import { createSlice } from '@reduxjs/toolkit';

//counter so parallel requests keep the loading bar until the last one finishes
const slice = createSlice({
  name: 'loading',
  initialState: { count: 0 },
  reducers: {
    load: (state) => { state.count += 1; },
    loaded: (state) => { state.count = Math.max(0, state.count - 1); }
  }
});

export const { load, loaded } = slice.actions;
export default slice.reducer;
